const BASE = 16; // 1rem = 16px

export const pxToRem = (pxString: string) => {
  if (!pxString) {
    return pxString;
  }

  return pxString
    .split(' ')
    .map((current) => {
      if (current && current.includes('px')) {
        const _current: number = Number(current.replace(/[^0-9]/g, ''));
        return `${_current / BASE}rem`;
      }
      return current;
    })
    .join(' ');
};

/**
 * The built-in error object
 * @extends Error
 *
 * @example
 * try {
 *    throw new CustomError('Error message')
 * }catch(error) {
 *    console.log((error as CustomError).message)
 * }
 */
export class CustomError extends Error {

  /**
   * @param {String} message - Error message
   */
  constructor(message: string) {

    super(message);
    Object.setPrototypeOf(this, CustomError.prototype);

  }

}